var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E53238",
    d: "m16.25 8.21 4.297 4.29-4.297 4.29v-2.102a.935.935 0 0 0-.937-.938h-4.688v-2.5h4.688c.519 0 .937-.418.937-.937zm6.25 4.29c0-.45-.18-.879-.496-1.195L17.469 6.78a1.813 1.813 0 0 0-3.094 1.282v1.312h-3.75c-1.035 0-1.875.84-1.875 1.875v2.5c0 1.035.84 1.875 1.875 1.875h3.75v1.313a1.814 1.814 0 0 0 3.094 1.28l4.535-4.523c.316-.316.496-.746.496-1.195M9.063 5.625c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H5.937A3.44 3.44 0 0 0 2.5 7.188v10.625a3.44 3.44 0 0 0 3.438 3.437h3.125c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H5.937c-.863 0-1.562-.7-1.562-1.562V7.188c0-.864.7-1.563 1.563-1.563z"
  })));
};
export default SvgLogout;